import OnboardingCard from "../OnboardingComponents/OnboardingCard";
import OnboardingHeader from "../OnboardingComponents/OnboardingHeader";
import OnboardingButton from "../OnboardingComponents/OnboardingButton";
import Spinner from "../OnboardingComponents/Spinner";
import { backStep, setStep } from "../../store/reducers/stepReducer";
import { RootState, useAppDispatch, useAppSelector } from "../../store/store";
import {
  useGetNdaValueQuery,
  useUpdateStagesMutation,
} from "../../services/api";
import useStep from "../../hooks/useStep";
import { setStage } from "../../store/reducers/stageReducer";
import { useEffect, useState } from "react";
import useHasPermission from "../../hooks/useHasPermission";
import { tracker } from "../../services/mixpanel";

function AgreementModal() {
  const dispatch = useAppDispatch();
  const { hasPermission } = useHasPermission();
  const { setStepFunc } = useStep();
  const stage = useAppSelector((state: RootState) => state.stage);
  const zohoCustomerId = useAppSelector(
    (state: RootState) => state.login.zohoCustomerId
  );
  const [isChecked, setIsChecked] = useState(false);
  const [updateStage] = useUpdateStagesMutation();
  const { data, isLoading } = useGetNdaValueQuery();
  const purlUser = useAppSelector((state) => state.purlUser);

  const handleCheckboxChange = () => {
    tracker.steps.nda.checkbox();
    setIsChecked(!isChecked);
  };

  const handleDisagree = () => {
    tracker.steps.nda.disagree();
    dispatch(backStep());
    const isNewSignInEnabled = !!localStorage.getItem("auth0Token") || purlUser?.New_Sign_In_Enabled === "Yes";
    localStorage.clear();
    if (isNewSignInEnabled) {
      window.location.href = window.location.origin + `/login`;
    }
  };

  const getStepFromPermissions = () => {
    if (hasPermission("video")) {
      return 2;
    }
    if (
      hasPermission("presentation") ||
      hasPermission("interactivePresentation")
    ) {
      return 3;
    }
    if (hasPermission("benefitCalculator")) {
      return 4;
    }
    return 5;
  };
  const handleClick = async () => {
    if (!isChecked) return;

    tracker.steps.nda.agree();

    const newStage = {
      ...stage,
      purlNdaChecked: Date.now().toString(),
    };
    dispatch(setStage(newStage));
    // const step = await setStepFunc(newStage);
    dispatch(setStep(getStepFromPermissions()));

    const updatedStage = await updateStage({
      zohoId: zohoCustomerId,
      key: "purlNdaChecked",
    });
  };

  useEffect(() => {
    tracker.steps.nda.pageView();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col items-center">
      <OnboardingHeader />
      
      <div className="w-full max-w-3xl px-4 mt-8 mb-12">
        <OnboardingCard>
          <div className="p-6 md:p-10">
            {isLoading ? (
              <div className="flex justify-center my-12">
                <Spinner />
              </div>
            ) : (
              <div className="flex flex-col">
                <h1 className="font-['Canela_Text'] text-3xl text-[#1A1F3C] mb-6 font-semibold">
                  {data?.data?.title}
                </h1>

                <div 
                  className="font-['Proxima_Nova'] text-[#1A1F3C] leading-relaxed text-base mb-8 overflow-y-auto max-h-[50vh] pr-2"
                  dangerouslySetInnerHTML={{
                    __html: (data?.data?.description) as unknown as TrustedHTML,
                  }}
                />
                
                <div className="flex items-center mb-8 pt-6 border-t border-gray-100">
                  <input
                    type="checkbox"
                    id="ndaCheckbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="h-5 w-5 accent-[#E2B042] rounded cursor-pointer"
                  />
                  <label htmlFor="ndaCheckbox" className="text-base mx-3 font-['Proxima_Nova'] text-[#1A1F3C] cursor-pointer select-none">
                    I agree to the terms and conditions
                  </label>
                </div>
                
                <div className="flex justify-end gap-4">
                  <OnboardingButton 
                    variant="outline" 
                    onClick={handleDisagree}
                    title="DISAGREE"
                  />
                  <OnboardingButton
                    variant="filled"
                    disabled={!isChecked}
                    onClick={handleClick}
                    title="AGREE"
                  />
                </div>
              </div>
            )}
          </div>
        </OnboardingCard>
      </div>
    </div>
  );
}

export default AgreementModal;
